import { ExternalLink, RefreshCw } from 'lucide-react';

import { ModalShell } from '@/components/common/modal-shell';
import { ObjectShowcase } from '@/components/common/object-showcase';
import { roomFriends } from '@/config';
import { useMediaQuery } from '@/hooks/use-media-query';
import { useRoomStore } from '@/stores/room-store';
import { resolveRoomAsset } from '@/utils/room-data';

export function DoorExitDialog() {
  const open = useRoomStore((state) => state.isDoorExitPromptOpen);
  const exitFriendId = useRoomStore((state) => state.doorExitFriendId);
  const refreshExitLink = useRoomStore((state) => state.refreshDoorExitLink);
  const setOpen = useRoomStore((state) => state.setDoorExitPromptOpen);
  const isDesktop = useMediaQuery('(min-width: 720px)');
  const friend = roomFriends.find((item) => item.id === exitFriendId);
  const friendImage = friend === undefined ? null : resolveRoomAsset(friend.image);

  const content = (
    <section className="door-exit-confirm" aria-label="友链跳转确认">
      {friend === undefined ? (
        <p className="empty-state">暂无可用友链。</p>
      ) : (
        <>
          <p>
            即将在新标签页打开友链 <strong>{friend.title}</strong>。
          </p>
          <div className="door-exit-destination">
            <div className="door-exit-link">
              {friendImage === null ? null : <img src={friendImage} alt="" />}
              <span>{friend.url}</span>
              <ExternalLink aria-hidden="true" size={15} />
            </div>
            <button
              type="button"
              className="icon-button"
              aria-label="随机刷新目的地"
              title="随机刷新目的地"
              onClick={refreshExitLink}
            >
              <RefreshCw aria-hidden="true" size={18} />
            </button>
          </div>
          {friend.description.length === 0 ? null : (
            <p className="door-exit-description">{friend.description}</p>
          )}
        </>
      )}
      <div className="door-exit-actions">
        <button type="button" className="secondary-action" onClick={() => setOpen(false)}>
          取消
        </button>
        {friend === undefined ? null : (
          <button
            type="button"
            className="primary-action"
            onClick={() => {
              window.open(friend.url, '_blank', 'noopener,noreferrer');
              setOpen(false);
            }}
          >
            前往{friend.title}
            <ExternalLink aria-hidden="true" size={16} />
          </button>
        )}
      </div>
    </section>
  );

  if (isDesktop) {
    return (
      <ObjectShowcase
        layout="door-bottom"
        open={open}
        onOpenChange={setOpen}
        title="门外的友链"
        description="门户已经开启，选择你的下一站"
      >
        {content}
      </ObjectShowcase>
    );
  }

  return (
    <ModalShell
      open={open}
      size="compact"
      title="门外的友链"
      description="门户已经开启，选择你的下一站"
      onOpenChange={setOpen}
    >
      {content}
    </ModalShell>
  );
}
